import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListMailingLists from './list/list';

const MailingListModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<ListMailingLists />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default MailingListModule;
